import { C } from "../../constants/theme";

export function Btn({ children, onClick, color=C.accent, small, outline, danger, disabled, style, ...rest }) {
  const clr = danger ? C.danger : color;
  return (
    <button {...rest} onClick={onClick} disabled={disabled}
      style={{ background:outline?"transparent":clr, border:"1.5px solid "+clr, color:outline?clr:"#fff", borderRadius:8, padding:small?"5px 12px":"9px 20px", fontSize:small?12:14, fontWeight:700, cursor:disabled?"default":"pointer", letterSpacing:.5, opacity:disabled?0.45:1, ...style }}
      onMouseEnter={e=>{ if(!disabled) e.currentTarget.style.opacity=".8"; }} onMouseLeave={e=>e.currentTarget.style.opacity=disabled?0.45:"1"}>{children}</button>
  );
}
